import { woodPanel, sectionHeading } from '@/shared/ui/game-theme';
import type { CharacterSnapshot } from '../types/character.types';
import {
  characterLabel,
  type CharacterLanguage,
} from '../utils/character-labels';
import { CharacterScale } from './character-scale';
import { characterPoles } from '../utils/character-poles';
import './hero-character.css';
export function CharacterPanel({
  profile,
  language,
  error,
  unavailable,
  embedded = false,
}: {
  profile: CharacterSnapshot['profile'] | null;
  language: CharacterLanguage;
  error: string | null;
  unavailable: boolean;
  embedded?: boolean;
}) {
  if (unavailable) return null;
  if (!profile)
    return (
      <section className="hero-character" style={embedded ? { background: 'none', border: 0, boxShadow: 'none', padding: 0 } : woodPanel}>
        <p role="status">
          {error
            ? characterLabel(language, error)
            : language === 'ru'
              ? 'Узнаём характер героя…'
              : 'Loading character…'}
        </p>
      </section>
    );
  const ru = language === 'ru';
  return (
    <section
      className="hero-character" style={embedded ? { background: 'none', border: 0, boxShadow: 'none', padding: 0 } : woodPanel}
      aria-label={ru ? 'Характер героя' : 'Hero character'}
    >
      {!embedded && <h3 style={sectionHeading}>{ru ? 'Характер' : 'Character'}</h3>}
      <dl className="character-traits">
        {Object.entries(profile.traits).map(([id, value]) => (
          <div key={id}>
            <dt>{characterLabel(language, id)}</dt>
            <dd><CharacterScale label={characterLabel(language, id)} value={value} poles={characterPoles(language, id)} language={language} /></dd>
          </div>
        ))}
      </dl>
      <h3 style={sectionHeading}>{ru ? 'Убеждения' : 'Beliefs'}</h3>
      {Object.keys(profile.beliefs).length ? (
        <ul>
          {Object.entries(profile.beliefs).map(([id, strength]) => (
            <li key={id}>
              {characterLabel(language, id)}{' '}
              <CharacterScale label={characterLabel(language, id)} value={strength} poles={characterPoles(language, 'belief')} language={language} />
            </li>
          ))}
        </ul>
      ) : (
        <p className="character-muted">
          {ru ? 'Убеждения ещё формируются.' : 'Beliefs are still forming.'}
        </p>
      )}
      <h3 style={sectionHeading}>{ru ? 'Отношение к вам' : 'Relationship with you'}</h3>
      <p>{characterLabel(language, profile.awarenessDescription)}</p>
      <dl className="character-traits">
        {([
          ['awareness', ru ? 'Осознание' : 'Awareness'],
          ['connection', ru ? 'Связь' : 'Connection'],
          ['trust', ru ? 'Доверие' : 'Trust'],
        ] as const).map(([id, label]) => (
          <div key={id}>
            <dt>{label}</dt>
            <dd>
              <CharacterScale label={label} value={profile.bond[id as keyof typeof profile.bond]} poles={characterPoles(language, id)} language={language} />
            </dd>
          </div>
        ))}
      </dl>
      {error && <p role="status">{characterLabel(language, error)}</p>}
    </section>
  );
}
